import { Component, Input, OnInit } from '@angular/core';
import { Pagination } from '../../models/pagination.model';
import { DepositCrypto } from '../../models/deposit-crypto.model';
import { LazyLoadEvent } from 'primeng/api';
import { ReportService } from '../../service/report.service';
import { Currency } from '../../models/currency.model';
import { User } from '../../models/user.model';
import Swal from 'sweetalert2';
import { TransferType } from '../../models/transfer-type.model';

@Component({
  selector: 'app-crypt-deposit-history',
  templateUrl: './crypt-deposit-history.component.html',
  styleUrls: ['./crypt-deposit-history.component.scss']
})
export class CryptDepositHistoryComponent implements OnInit {

  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  loading = true;
  page = 1;
  limit = 15;
  pagination: Pagination<DepositCrypto> = new Pagination<DepositCrypto>();
  @Input() selectedCurrency: Currency[] = [];
  @Input() includedUsers: User[] = [];
  @Input() showOnlyManualDeposits = false;

  constructor(private reportService: ReportService) {
  }

  changeRecordPerPageLimit(limit: number): void {
    this.limit = limit;
    this.getDepositList({
      first: 0,
      rows: limit
    });
  }


  copy(text: string, alert: string): void {
    navigator.clipboard.writeText(text);
    this.Toast.fire({ icon: 'success', text: alert });
  }

  getDepositList(event: LazyLoadEvent = {}): void {
    this.loading = true;
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.limit + 1;
    }
    const currenciesId = this.selectedCurrency.map((currency) => currency.id);
    const userIds = this.includedUsers.map((user) => user.id);
    this.reportService
      .getCryptoDepositList(userIds, currenciesId,this.showOnlyManualDeposits, this.page, event.rows)
      .subscribe((pagination) => {
        this.pagination = pagination;
        this.loading = false;
      });
  }

  ngOnInit(): void {
  }

  protected readonly TransferType = TransferType;
}
